type TLeagueoflegends =
|'name'
|'maps.summonersrift'
|'maps.howlingabyss'
|'gamemodes.battlearena'
;
const LeagueoflegendsNS = 'leagueoflegends';
function LeagueoflegendsF(_: TLeagueoflegends): string { return `${LeagueoflegendsNS}:${_}`; }
export {LeagueoflegendsF,LeagueoflegendsNS,TLeagueoflegends};
